/* eslint-disable jsx-a11y/anchor-is-valid */
// import clsx from 'clsx'
import {FC} from 'react'
// import {toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'
import {User} from '../../core/_models'

type Props = {
  User: User
}

const UserDescCell: FC<Props> = ({User}) => {
  let roles: any = []

  if (User.roles !== undefined) {
    roles = User.roles
  }

  return (
    <div className='d-flex align-items-center'>
      <div className='symbol symbol-circle symbol-50px overflow-hidden'></div>

      <div className='d-flex flex-column align-items-center'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {roles.length > 0 ? (
            <div className='badge badge-light-success fw-bolder fs-5'>{roles[0].name}</div>
          ) : (
            ''
          )}
        </a>
      </div>
    </div>
  )
}

export {UserDescCell}
